import { render } from "./BaseAccordion.vue?vue&type=template&id=08db1c93"
import script from "./BaseAccordion.vue?vue&type=script&lang=ts"
export * from "./BaseAccordion.vue?vue&type=script&lang=ts"

import "./BaseAccordion.vue?vue&type=style&index=0&id=08db1c93&lang=scss"
script.render = render

export default script